import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 302  -  震动
 */

export default class EventShake extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['5', '5', '0', '20', '', '0']
  }

  // #region 事件内关键属性参数
  /**
   * 强度
   */
  get Intensity() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Intensity(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 速度
   */
  get Speed() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Speed(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 是否循环(1,0)
   */
  get IsFor() {
    return this.Parameter?.[2] == '1'
  }
  set IsFor(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '0')
  }

  /**
   * 非循环时震动时间
   */
  get ShakeTime() {
    return Number(this.Parameter?.[3] ?? '0') || 0
  }
  set ShakeTime(value) {
    this.Parameter && (this.Parameter[3] = String(value ?? 0))
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[4] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  get Type() {
    return parseInt(this.Parameter?.[5] ?? '0', 10) || 0
  }

  set Type(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.Shake

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
